import {
    VENDOR_BILL_APPROVE_SET_COMMENT,
    VENDOR_BILL_APPROVE_SET_ID,
    VENDOR_BILL_APPROVE_UNSET_ID,
    VENDOR_BILL_APPROVE_TOGGLE_SELECT_ALL,
    VENDOR_BILL_APPROVE_CLEAR_IDS
} from "../types";

const initialState = {
    comment: "",
    vendorBillApproveIds: [],
    updatedIndex: {}
};

export default function(state = initialState, action) {
    const { type } = action;

    switch (type) {
        case VENDOR_BILL_APPROVE_TOGGLE_SELECT_ALL:
            return {
                ...state,
                vendorBillApproveIds: action.payload.ids,
                updatedIndex: action.payload.updatedIndex
            };
        case VENDOR_BILL_APPROVE_SET_COMMENT: {
            return {
                ...state,
                comment: action.payload
            };
        }
        case VENDOR_BILL_APPROVE_SET_ID: {
            return {
                ...state,
                vendorBillApproveIds: state.vendorBillApproveIds.concat(action.payload),
                updatedIndex: {
                    ...state.updatedIndex,
                    [action.payload]: true
                }
            };
        }
        case VENDOR_BILL_APPROVE_UNSET_ID: {
            return {
                ...state,
                vendorBillApproveIds: state.vendorBillApproveIds.filter(id => id !== action.payload),
                updatedIndex: {
                    ...state.updatedIndex,
                    [action.payload]: undefined
                }
            };
        }
        case VENDOR_BILL_APPROVE_CLEAR_IDS: {
            return {
                ...state,
                comment: "",
                vendorBillApproveIds: [],
                updatedIndex: {}
            };
        }
        default:
            return state;
    }
}
